import { TableFormItem } from "@/containers/ProjectTemplate/styled";
import { IFormFieldOptions } from "@/interfaces";
import { Checkbox, Select, Space } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { useEffect, useState } from "react";

interface IProps {
  value: string[];
  valueAll: boolean;
  valueNone: boolean;
  options: IFormFieldOptions;
  disabled?: boolean;
  onChange(data: string[], all: boolean, none: boolean): void;
}

export const TableCheckboxMultiSelect = ({
  value,
  valueAll,
  valueNone,
  options,
  disabled = false,
  onChange,
}: IProps) => {
  const [convertedOptions, setConvertedOptions] = useState<DefaultOptionType[]>(
    []
  );

  const handleChangeAll = (changeEvent: CheckboxChangeEvent) => {
    value = convertedOptions.map((x) => x.value as string);
    if (changeEvent.target.checked === false) {
      onChange([], changeEvent.target.checked, false);
    } else {
      onChange(value, changeEvent.target.checked, false);
    }
  };

  const handleChangeNone = (changeEvent: CheckboxChangeEvent) => {
    onChange([], false, changeEvent.target.checked);
  };

  const handleChange = (data: string[], valueNone: boolean) => {
    value = convertedOptions.map((x) => x.value as string);
    onChange(data, data.length === value.length, valueNone);
  };

  useEffect(() => {
    if (!options) return;

    const newConvertedOptions = Object.keys(options).map((key) => ({
      value: key,
      label: options[key].fallback,
    }));

    setConvertedOptions(newConvertedOptions);
  }, [onChange, value, valueAll, options]);

  return (
    <TableFormItem>
      <>
        <Space>
          <Checkbox
            data-test-id="table-checkbox-none"
            checked={valueNone}
            onChange={(data): void => handleChangeNone(data)}
            disabled={disabled}
          />
          None
          <Checkbox
            data-test-id="table-checkbox-all"
            checked={valueAll}
            onChange={(data): void => handleChangeAll(data)}
            disabled={disabled}
          />
          All
        </Space>
        {!(valueAll || valueNone) && (
          <Select
            data-test-id="table-multiselect"
            mode="multiple"
            allowClear
            options={convertedOptions}
            defaultValue={value ?? []}
            value={value ?? []}
            onChange={(data): void => handleChange(data, valueNone)}
            disabled={disabled}
          />
        )}
      </>
    </TableFormItem>
  );
};
